module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921002651_T.0a94761e.jpg";